"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GuestApplication() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const content_items = [{
    id: 1,
    text: "Trenecitos"
  }, {
    id: 2,
    text: "Shuttle interno"
  }, {
    id: 3,
    text: "Transporte playa-hotel"
  }, {
    id: 4,
    text: "Transporte entre áreas del resort"
  }];
  const benefits = [{
    id: 1,
    text: "Menos tiempo de espera"
  }, {
    id: 2,
    text: "Más comodidad"
  }, {
    id: 3,
    text: "Mayor satisfacción"
  }];
  return <section data-section-id="3035" id="guest-application" className="relative bg-background text-foreground py-24 md:py-32 lg:py-44 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-y-8 mb-20 md:mb-28 lg:mb-32 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-start-2 lg:col-span-10 flex items-center gap-3 mb-4">
            <span className="inline-block w-2 h-2 rounded-lg bg-primary" />
            <span className="font-mono text-xs tracking-[0.25em] uppercase text-muted-foreground">
              Guest Mobility
            </span>
          </div>
          <h2 className="lg:col-start-2 lg:col-span-8 font-default text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-foreground">
            Información en tiempo real para{" "}
            <em className="italic text-primary font-medium">transporte</em> interno.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24">
          <div ref={card1Ref} className={`transition-all duration-1000 ease-out ${card1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h3 className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground mb-8 border-b border-border pb-4">
              Servicios Incluidos
            </h3>
            <ul className="space-y-6">
              {content_items.map((item, i) => <li key={item.id} data-index={i} className="flex items-start gap-4 group">
                  <span className="mt-2.5 size-1.5 rounded-lg bg-primary shrink-0" />
                  <span className="font-default text-xl md:text-2xl text-foreground group-hover:translate-x-2 transition-transform duration-300">
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </div>

          <div ref={card2Ref} className={`transition-all duration-1000 ease-out delay-150 ${card2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h3 className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground mb-8 border-b border-border pb-4">
              Beneficios Clave
            </h3>
            <ul className="space-y-6">
              {benefits.map((benefit, i) => <li key={benefit.id} data-index={i} className="flex items-start gap-4 group">
                  <span className="mt-2.5 size-1.5 rounded-lg bg-accent shrink-0" />
                  <span className="font-default text-xl md:text-2xl text-foreground group-hover:translate-x-2 transition-transform duration-300">
                    {benefit.text}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}